import { defineComponent as _defineComponent } from 'vue'
import { SelectedProviderVariants } from '@/typings/printify/printProvider';


export default /*#__PURE__*/_defineComponent({
  __name: 'RevisionStep',
  props: {
    podService: null,
    productTitle: null,
    providerVariants: null
  },
  setup(__props: any) {

const props = __props as { podService: string, productTitle: string, providerVariants: SelectedProviderVariants[] };



return { __sfc: true,props }
}

})